let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4sjt4")).then(() => parcelRequire('gM6Za'));